module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/430fec58404987993c5037925ee62c98.png";